import React from 'react';
import Storage from '../common/Storage';
import axios from 'axios';
import Constants from '../common/Constants';
import SimpleModal from '../common/SimpleModal';

class AdminVisitTypes extends React.Component {
    constructor(props) {
        super(props);

        let user = Storage.getItem('CurrentUser');

        this.state = {
            user,
            visitTypeList: [],
            newId: 0,
            savedModalShow: false
        };
    }

    loadVisitTypes = () => {
        axios.get(Constants.URL_API + 'VisitType/GetAll', { headers: Storage.getAuth() })
            .then(res => {
                let visitTypeList = res.data;
                visitTypeList.sort((a, b) => (a.name > b.name ? 1 : -1));
                this.setState({ visitTypeList });
            })
            .catch((error) => {
                if (error.response) {
                    this.setState({ apiCode: error.response.status });
                } else if (error.request) {
                    this.setState({ apiCode: 0 });
                } else {
                    this.setState({ apiCode: 0 });
                    console.log('Error', error.message);
                }
            });
    }
    
    reloadData = () => {
        this.loadVisitTypes();
    }

    componentDidMount() {
        this.reloadData();
        if (this.props.setSave) { this.props.setSave(this.Save); }
    }

    DeleteItem = (r) => {
        this.PropertyUpdate(r, { rowStatus: Constants.STATUS_DELETE });
    }

    Add = () => {
        let visitTypeList = this.state.visitTypeList;
        let newId = this.state.newId - 1;

        visitTypeList.unshift({ visitTypeId: newId, name: "", rowStatus: Constants.STATUS_NEW });
        this.setState({ visitTypeList, newId });
    }
    
    PropertyUpdate = (r, newObj) => {
        let visitTypeList = this.state.visitTypeList;
        let visitType = visitTypeList.find((i) => i.visitTypeId === r.visitTypeId);
        Object.assign(visitType, { rowStatus: Constants.STATUS_EDIT }, newObj);
        this.setState(visitTypeList);
    }
    
    ChangeName = (r, e) => {
        this.PropertyUpdate(r, { name: e.target.value });
    }

    ChangePublic = (r, e) => {
        this.PropertyUpdate(r, { isPublic: e.target.checked });
    }
    
    Save = () => {
        this.Create();
        this.Update();
        this.Delete();
        this.setState({ savedModalShow: true });
    }

    CleanStatus = () => {
        let visitTypeList = this.state.visitTypeList;
        visitTypeList.forEach(u => u.rowStatus = null);
        this.setState({ visitTypeList });
    }

    

    Create = () => {
        let list = this.state.visitTypeList.filter(u => u.visitTypeId < 0 && u.rowStatus == Constants.STATUS_EDIT);
        this.SaveAPI("CreateMultiple", "post", list);
    }
    
    Update = () => {
        let list = this.state.visitTypeList.filter(u => u.visitTypeId > 0 && u.rowStatus == Constants.STATUS_EDIT);
        this.SaveAPI("UpdateMultiple", "put", list);
    }

    Delete = () => {
        let list = this.state.visitTypeList.filter(u => u.visitTypeId > 0 && u.rowStatus == Constants.STATUS_DELETE);
        let ids = list.map(u => u.visitTypeId);
        this.SaveAPI("DeleteMultiple", "delete", ids);
    }
    
    SaveAPI = (action, method, data) => {
        if (data.length == 0) { return; }
        axios(Constants.URL_API + 'VisitType/' + action, { method, data, headers: Storage.getAuth() })
            .then(res => {
                //this.setState({ userList: res.data });
            })
            .catch((error) => {
                if (error.response) {
                    this.setState({ apiCode: error.response.status });
                } else if (error.request) {
                    this.setState({ apiCode: 0 });
                } else {
                    this.setState({ apiCode: 0 });
                    console.log('Error', error.message);
                }
            });
    }
    
    render() {
        return (
            <div>
                <SimpleModal body="Los cambios se han guardado correctamente" okText="Gracias!" show={this.state.savedModalShow} onClose={() => { this.setState({ savedModalShow: false }); this.loadVisitTypes(); }} />
                <h4>
                    <span className="mr-2">Tipos de Visita</span>
                    <button className="btn btn-sm btn-success" onClick={this.Add}><span className="fa fa-plus"></span></button>
                    <button className="btn btn-sm btn-primary" onClick={this.Save}><span className="fa fa-save"></span></button>
                </h4>

                <div className="row">
                    <div className="col-sm-6">Nombre</div>
                    <div className="col-sm-2">Publico</div>
                    <div className="col-sm-4">Acciones</div>
                </div>

                {this.state.visitTypeList.map((r, i) =>
                    <div key={r.visitTypeId} className={"row " + (r.rowStatus == Constants.STATUS_EDIT ? "bg-warning" : (r.rowStatus == Constants.STATUS_NEW ? "bg-success" : (r.rowStatus == Constants.STATUS_DELETE ? "bg-danger" : "")))} style={{ backgroundColor: i % 2 === 0 ? 'white' : 'light-gray' }}>
                        <div className="col-sm-6"><input className="form-control" type="text" value={r.name} onChange={(e) => { this.ChangeName(r, e); }} /></div>
                        <div className="col-sm-2">
                            <div className="checkbox">
                                <label><input type="checkbox" defaultChecked={r.isPublic} onChange={(e) => { this.ChangePublic(r, e); }}></input></label>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <button className="btn btn-sm btn-danger" onClick={() => { this.DeleteItem(r);}} value={r.visitTypeId}><span className="fa fa-trash"></span></button>
                        </div>
                    </div>
                    )
                }
            </div>
        );
    }
}

export default AdminVisitTypes;